export const formatPrice = (price) => {
  const decimals = Number.isSafeInteger(parseFloat(price)) ? 0 : 2
  return parseFloat(price).toFixed(decimals)
}
